// src/api/userService.ts
import apiClient from './config';
import { LoginResponse } from '../types/interfaces';


export const loginUser = async (email: string, password: string): Promise<LoginResponse> => {
  try {
    const response = await apiClient.post('/users/login', { email, password });
    localStorage.setItem('token', response.data.access_token);
    return response.data;
  } catch (error: any) {
    return { access_token: '', token_type: '', error: error.response?.data?.error };
  }
};

export const registerUser = async (email: string, password: string,  first_name: string, last_name: string) => {
  try {
    const response = await apiClient.post('/users/register', { email, password, first_name, last_name});
    return response.data;
  } catch (error: any) {
    return { error: error.response?.data?.error };
  }
};

export const resetPassword = async (token: string, new_password: string) => {
  try {
    const response = await apiClient.post('/users/reset-password', { token, new_password });
    return response.data;
  } catch (error: any) {
    return { error: error.response?.data?.error };
  }
};

export const requestPasswordReset = async (email: string) => {
  try {
    const response = await apiClient.post('/users/forgot-password', { email });
    return response.data; 
  } catch (error: any) {
    return { error: error.response?.data?.error};
  }
};

export const getUserMe = async () => {
  try {
    const response = await apiClient.get('/users/me');
    return response.data;
  } catch (error: any) {
    return null;
  }
};

export const logoutUser = () => {
  localStorage.removeItem('token');
  window.location.href = '/login';
};

export const isAuthenticated = (): boolean => {
  return !!localStorage.getItem('token');
};


export const validateToken = async () => {
  try {
    const response = await apiClient.get('/auth/validate-token');
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.detail);
  }
};


export const getUserPayments = async () => {
  try {
    const response = await apiClient.get('/users/payments');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const changeName = async (newFirstName: string, newLastName: string) => {
  await apiClient.put('/users/changename', {
    new_first_name: newFirstName,
    new_last_name: newLastName,
  });
};

export const changeLanguage = async (newLanguage: string) => {
  await apiClient.put('/users/changelanguage', {
    new_language: newLanguage,
  });
};

export const changePassword = async (oldPassword: string, newPassword: string) => {
  const response = await apiClient.put('/users/changepassword', {
    old_password: oldPassword,
    new_password: newPassword,
  });

  if (response.data.error) {
    throw new Error(response.data.error);
  }
  
  return response.data;
};

export const changePhone = async (newPhone: string) => {
  await apiClient.put('/users/changephone', {
    new_phone: newPhone,
  });
};

export const changeBornDate = async (bornDate: string) => {
  await apiClient.put('/users/changeborndate', {
    new_born_date: bornDate,
  });
};